import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';

// Components
import Tags from '../Tags';
import Social from '../Social';

interface RelatedArticleProps {
    title: string;
    id: string;
    effective: string;
    parent: {
        title: string;
    }
    subjects?: string[];
}

const RelatedArticle: React.FC<RelatedArticleProps> = ({ title, subjects, id, effective, parent }) => {
    const date = effective && moment(effective).format("DD/MM/YYYY");
    const category = id.split('/').slice(4, -1);

    return (
        <div className="related-article">
            <div className="flex social-bar">
                <Social subjects={subjects} id={id} title={title} category={category[0]}/>
                <div className="article__info">
                    {date && <div className="date">{date}</div>}
                </div>
            </div>
            {id && (
                <Link to={`/${category[0]}/${id.split('/').pop()}`}>
                    <h3 className="title">{title}</h3>
                </Link>
            )}
            <Tags parent={parent} related_category={category[0]} subjects={subjects} />
        </div>
    )
}

export default RelatedArticle;